module.exports = __webpack_public_path__ + "img/1040Y.f098dabd.png";